import { serializeObject } from "../common/helper";
import { Request } from "./HttpService";

export const GlobalService = {
  SearchCandidate(pageSize, pageNumber, search) {
    let serialized = serializeObject(search);
    return Request(
      `vitae/global/Candidates/${pageSize}/${pageNumber}?${serialized}`,
      "get"
    );
  },
  GetPrecandidateById(id) {
    return Request(`vitae/global/Precandidates/${id}`, "get");
  },
  getInterviewDetails(id) {
    return Request(`vitae/global/Interviews/${id}`, "get");
  },
  createInterviewInOtherCompany(request) {
    return Request("vitae/global/create", "post", request);
  }
};
